import { render, staticRenderFns } from "./CpttEditAbout.vue?vue&type=template&id=7517aefe&scoped=true&"
import script from "./CpttEditAbout.vue?vue&type=script&lang=js&"
export * from "./CpttEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7517aefe",
  null
  
)

export default component.exports